export const moistureLoadManager = "moisture-load-manager";
export const newMoistureLoad = "new-moisture-load";
export const userSettings = "user-settings";
export const systemManager = "system-manager";
export const pricingManager = "pricing-manager";
export const newPricing = "new-pricing";
export const newSystem = "new-system";
export const about = "about";
export const reset = "reset";
export const systemSelectionGuide = "system-selection-guide";
export const system = "system";
export const pricing = "pricing";
export const moistureLoad = "moisture-load";
export const tools = "tools";
export const drySize = "dry-size";
export const logViewer = "log-viewer";
